// id пункта Мониторинг загрузки данных зафиксирован на бэке
export const EXPIRED_INDICATOR_MENU_ITEM_ID = 310;

type TMenuItemLike = {
  id?: number;
  items?: TMenuItemLike[] | null;
};

export const isExpiredIndicatorMenuItem = (item?: TMenuItemLike | null): boolean =>
  !!item &&
  (item.id === EXPIRED_INDICATOR_MENU_ITEM_ID ||
    (Array.isArray(item.items) && item.items.some(isExpiredIndicatorMenuItem)));
